import { NotificationLine } from './NotificationLine';
import { INotificationLine } from '../Menu.interfaces';

export default NotificationLine;
export { NotificationLine, INotificationLine };
